// Action Types
export const SET_LICENSE_PLATE_INFO = 'SET_LICENSE_PLATE_INFO';
export const CLEAR_CURRENT_LICENSE_PLATE = 'CLEAR_CURRENT_LICENSE_PLATE';

const initialState = {
  currentLicensePlate: null,
  /* The plate the car above was looked up with ({ type, payload, reg }).
   * The car and its plate travel together: read from anywhere else (the
   * profile, this browser's storage), the plate could belong to another car
   * — a Volvo shown as WMM 191, a Peugeot's plate (P25009-482). null when
   * the dispatcher did not know it. */
  currentLicensePlateReg: null,
};

const currentLicensePlateReducer = (state = initialState, action = {}) => {
  const { type, payload } = action;
  switch (type) {
    case SET_LICENSE_PLATE_INFO:
      return {
        ...state,
        currentLicensePlate: payload,
        currentLicensePlateReg: action.reg || null,
      };
    case CLEAR_CURRENT_LICENSE_PLATE:
      return {
        ...state,
        currentLicensePlate: null,
        currentLicensePlateReg: null,
      };
    default:
      return state;
  }
};

export default currentLicensePlateReducer;
